import { makeStyles } from '@fluentui/react-components';

export const useBreadcrumbStyles = makeStyles({
  breadcrumbButton: {
    '&.fui-BreadcrumbButton': {
      color: '#0F6CBD',
    },
  },
  breadcrumbButtonCurrent: {
    '&.fui-BreadcrumbButton': {
      color: '#424242',
      fontWeight: 400,
    },
  },
  breadcrumbContainer: {
    marginBottom: '24px',
  },
});
